import { render, staticRenderFns } from "./DevSwitchPlanForm.vue?vue&type=template&id=0749bd9e&"
import script from "./DevSwitchPlanForm.vue?vue&type=script&lang=js&"
export * from "./DevSwitchPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports